import axios from "axios";
export const get_credietitial = async (dispatch) => {
  console.log(process.env.REACT_APP_BACK_END_URL);

  try {
    let res = await axios.post(
      process.env.REACT_APP_BACK_END_URL + "/api/iipsys/v1/login",

      {
        info: {
          lang: "EN",
        },
        input: {
          login_name: document.getElementById("user_name").value,
          login_password: document.getElementById("user_password").value,
          actioncode: "1",
        },
      },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      },
    );
      console.log("login data = ", res)
    if (res.data.output.user_cd) {
      // alert("ok" + res.data.output.user_cd)
      if (typeof Storage !== undefined) {
          localStorage.setItem("amanrowuserData", JSON.stringify(
              {
                user_cd: res.data.output.user_cd,
                barnch_cd: res.data.output.barnch_cd,
                company_cd: res.data.output.company_cd,
                lang: res.data.output.language_cd,
                login_name: document.getElementById("user_name").value,
                email: res.data.output.email_address,
                token: res.data.result.token,
          }),
        );

        const data = {
          user_cd: res.data.output.user_cd,
          company_cd: res.data.output.company_cd,
          user_language_cd: res.data.output.language_cd,
          login_name: document.getElementById("user_name").value,
          email: res.data.output.email_address,
          token: res.data.result.token,
          };
        
        dispatch({ type: "USERINFO", payload: data }); //to store in redux
      } else {
        alert("update the browser");
      }
      window.location = "/main";
    } else {
      alert("wrong creditential");
    }
  } catch (err) {
    console.log("error", err);
    alert(err.message);
  }
};
